// M12 - MotricityKpiCard
//
// Tarjeta KPI reutilizable para visualizaciones de juegos VR de
// motricidad. Muestra un titulo, un valor grande y un subtitulo
// opcional con color de acento.

import React from "react";
import { Card, Typography } from "antd";
import "./MotricityKpiCard.scss";

const { Text } = Typography;

export function MotricityKpiCard({ title, value, suffix, hint, accent }) {
  const accentClass = accent ? `motricity-kpi-card--${accent}` : "";
  return (
    <Card className={`motricity-kpi-card ${accentClass}`} variant="outlined">
      <div className="motricity-kpi-card__title">{title}</div>
      <div className="motricity-kpi-card__value">
        {value}
        {suffix ? (
          <span className="motricity-kpi-card__suffix">{suffix}</span>
        ) : null}
      </div>
      {hint ? (
        <Text type="secondary" className="motricity-kpi-card__hint">
          {hint}
        </Text>
      ) : null}
    </Card>
  );
}
